import {http} from "../http-common";
import { IPermissionRequestData, IPermissionResponseData } from "../types/Permission";

const getAll = () => {
  return http.get<Array<IPermissionResponseData>>("/permissions");
};

const get = (id: number) => {
  return http.get<IPermissionResponseData>(`/permissions/${id}`);
};

const create = (data: IPermissionRequestData) => {
  return http.post<IPermissionRequestData>("/permissions", data);
};

const update = (id: number, data: IPermissionRequestData) => {
  return http.put<IPermissionRequestData>(`/permissions/${id}`, data);
};

const remove = (id: number) => {
  return http.delete<any>(`/permissions/${id}`);
};

const PermissionService = {
  getAll,
  get,
  create,
  update,
  remove,
};

export default PermissionService;
